<script setup>
import routes from '@/constants/routes';

defineProps({
  referenceRef: {
    type: Object,
    default: undefined,
  },
});
const emit = defineEmits(['redirect']);

const { t } = useI18n();

// dropdown
const dropdownRef = ref(null);
function closeDropdown() {
  if (!dropdownRef.value) return;
  dropdownRef.value.close();
}

function handleRedirect(link) {
  closeDropdown();
  emit('redirect', link);
}
</script>

<template>
  <UiDropdown
    ref="dropdownRef"
    class="ui-dropdown-trains-navigation"
    :reference-ref="referenceRef"
    position="bottom-center"
    use-v-if
  >
    <template #trigger>
      <CLocalizedLink
        class="ui-dropdown-trains-navigation__trigger"
        :to="routes.WIKI"
        @click="closeDropdown"
      >
        <span class="ui-dropdown-trains-navigation__font">
          {{ t('header.trains') }}
        </span>
      </CLocalizedLink>
    </template>

    <template #content>
      <BundlesTrainsNavigation
        class="ui-dropdown-trains-navigation__container"
        @redirect="handleRedirect"
      />
    </template>
  </UiDropdown>
</template>
